var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.666,
    height: 28.56,
    viewBox: "0 0 24.666 28.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5139",
    "data-name": "Path 5139",
    d: "M22.174,2H6.6A2.6,2.6,0,0,0,4,4.6V22.771H6.6V4.6H22.174Zm3.895,5.193H11.789a2.6,2.6,0,0,0-2.6,2.6V27.963a2.6,2.6,0,0,0,2.6,2.6h14.28a2.6,2.6,0,0,0,2.6-2.6V9.789A2.6,2.6,0,0,0,26.069,7.193Zm0,20.771H11.789V9.789h14.28Z",
    fill: "#01875f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.79a82d07f07ff1bcee857dc880af314c.svg";
export { ForwardRef as ReactComponent };